import { PERMISSIONS } from './permissions';

export const STANDARD_ROLES = {
  client_admin: [
    PERMISSIONS.TENDER_CREATE,
    PERMISSIONS.TENDER_VIEW_CLIENT,
    PERMISSIONS.TENDER_FILES_VIEW_CLIENT,
    PERMISSIONS.TENDER_SECTIONS_VIEW_CLIENT,
    PERMISSIONS.TENDER_EDIT,
    PERMISSIONS.TENDER_DELETE,
    PERMISSIONS.TENDER_MANAGE_TEAM,
    PERMISSIONS.PUBLIC_TENDER_VIEW,
    PERMISSIONS.PARTNER_VIEW,
    PERMISSIONS.PARTNER_MANAGE,
    PERMISSIONS.LIBRARY_MANAGE_CLIENT,
    PERMISSIONS.DRAFT_CREATE,
    PERMISSIONS.DRAFT_EDIT,
    PERMISSIONS.REVIEW_CREATE,
    PERMISSIONS.REPORT_CREATE,
    PERMISSIONS.INSIGHTS_VIEW,
    PERMISSIONS.USER_INVITE,
    PERMISSIONS.USER_VIEW,
    PERMISSIONS.USER_UPDATE,
    PERMISSIONS.USER_DELETE,
    PERMISSIONS.USER_MANAGE_ROLES,
    PERMISSIONS.USER_MANAGE_LIMITS,
    PERMISSIONS.TEAM_CREATE,
    PERMISSIONS.TEAM_VIEW,
    PERMISSIONS.TEAM_UPDATE,
    PERMISSIONS.TEAM_DELETE,
    PERMISSIONS.TEAM_MANAGE_LIMITS,
    PERMISSIONS.CLIENT_PROFILE_UPDATE,
    PERMISSIONS.CLIENT_VIEW,
    PERMISSIONS.BILLING_MANAGE,
    PERMISSIONS.SETTINGS_MANAGE,
    PERMISSIONS.TICKET_CREATE,
    PERMISSIONS.TICKET_VIEW,
    PERMISSIONS.TICKET_UPDATE,
    PERMISSIONS.TICKET_MANAGE,
    PERMISSIONS.TEMPLATE_VIEW_CLIENT,
    PERMISSIONS.TEMPLATE_CREATE,
    PERMISSIONS.TEMPLATE_EDIT,
    PERMISSIONS.TEMPLATE_DELETE,
    PERMISSIONS.TEMPLATE_UPLOAD_TEAM,
    PERMISSIONS.TEMPLATE_MANAGE_CLIENT,
    PERMISSIONS.LIBRARY_VIEW_CLIENT,
    PERMISSIONS.LIBRARY_UPLOAD_TEAM,
    PERMISSIONS.LIBRARY_DELETE,
    PERMISSIONS.PROCUREMENT_ACCESS,
  ],
  team_lead: [
    PERMISSIONS.TENDER_CREATE,
    PERMISSIONS.TENDER_VIEW,
    PERMISSIONS.TENDER_FILES_VIEW_CLIENT,
    PERMISSIONS.TENDER_SECTIONS_VIEW_CLIENT,
    PERMISSIONS.TENDER_EDIT,
    PERMISSIONS.TENDER_DELETE,
    PERMISSIONS.TENDER_MANAGE_TEAM,
    PERMISSIONS.PUBLIC_TENDER_VIEW,
    PERMISSIONS.PARTNER_VIEW,
    PERMISSIONS.LIBRARY_MANAGE_CLIENT,
    PERMISSIONS.DRAFT_CREATE,
    PERMISSIONS.DRAFT_EDIT,
    PERMISSIONS.REVIEW_CREATE,
    PERMISSIONS.REPORT_CREATE,
    PERMISSIONS.INSIGHTS_VIEW,
    PERMISSIONS.USER_VIEW,
    PERMISSIONS.USER_MANAGE_LIMITS,
    PERMISSIONS.TEAM_VIEW,
    PERMISSIONS.TICKET_CREATE,
    PERMISSIONS.TICKET_VIEW,
    PERMISSIONS.TICKET_UPDATE,
    PERMISSIONS.TEMPLATE_VIEW_CLIENT,
    PERMISSIONS.TEMPLATE_CREATE,
    PERMISSIONS.TEMPLATE_EDIT,
    PERMISSIONS.TEMPLATE_DELETE,
    PERMISSIONS.TEMPLATE_UPLOAD_TEAM,
    PERMISSIONS.LIBRARY_VIEW_CLIENT,
    PERMISSIONS.LIBRARY_UPLOAD_TEAM,
    PERMISSIONS.LIBRARY_DELETE,
    PERMISSIONS.CLIENT_VIEW,
    PERMISSIONS.PROCUREMENT_ACCESS,
  ],
  user: [
    PERMISSIONS.TENDER_CREATE,
    PERMISSIONS.TENDER_VIEW,
    PERMISSIONS.TENDER_EDIT,
    PERMISSIONS.PUBLIC_TENDER_VIEW,
    PERMISSIONS.DRAFT_CREATE,
    PERMISSIONS.DRAFT_EDIT,
    PERMISSIONS.REVIEW_CREATE,
    PERMISSIONS.REPORT_CREATE,
    PERMISSIONS.TICKET_CREATE,
    PERMISSIONS.TICKET_VIEW,
    PERMISSIONS.TICKET_UPDATE,
    PERMISSIONS.TEMPLATE_VIEW_CLIENT,
    PERMISSIONS.LIBRARY_VIEW_CLIENT,
    PERMISSIONS.CLIENT_VIEW,
    PERMISSIONS.PROCUREMENT_ACCESS,
  ],
  restricted_editor: [
    PERMISSIONS.TENDER_VIEW,
    PERMISSIONS.TENDER_EDIT,
    PERMISSIONS.DRAFT_EDIT,

    PERMISSIONS.TICKET_CREATE,
    PERMISSIONS.TICKET_VIEW,
  ],
  evaluator: [
    PERMISSIONS.PROCUREMENT_ACCESS,
    PERMISSIONS.TICKET_CREATE,
    PERMISSIONS.TICKET_VIEW,
    PERMISSIONS.CLIENT_VIEW,
  ],
};

export const getPermissionsForRole = (role: string): string[] => {
  return STANDARD_ROLES[role as keyof typeof STANDARD_ROLES] || [];
};
